import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { BrowserManagerDataDispatcher } from './browser-manager-data.dispatcher';
import { BrowserManagerDataEffects } from './browser-manager-data.effects';
import { FEATURE_NAME, reducer } from './browser-manager-data.reducer';
import { BrowserManagerDataService } from './browser-manager-data.service';
import { BrowserManagerDataStore } from './browser-manager-data.store';
import { CookieService } from './cookie.service';
import { LocalStorageService } from './local-storage.service';
import { MobileGuard } from './mobile.guard';

export const browserManagerDataEffects = [BrowserManagerDataEffects];

@NgModule({
  imports: [CommonModule, StoreModule.forFeature(FEATURE_NAME, reducer)],
})
export class BrowserManagerDataModule {
  static forRoot(): ModuleWithProviders<BrowserManagerDataModule> {
    return {
      ngModule: BrowserManagerDataModule,
      providers: [
        BrowserManagerDataService,
        LocalStorageService,
        CookieService,
        BrowserManagerDataDispatcher,
        MobileGuard,
        BrowserManagerDataStore,
      ],
    };
  }
}
